import { useMemo, useState } from 'react'
import styled from 'styled-components'

const ExpandableList = ({ children, props }: { typing?: boolean; children: any; props: any }) => {
    const [showAll, setShowAll] = useState(false)

    const filteredChildren = children.filter((child: any) => child !== '\n')

    const displayedChildren = showAll ? filteredChildren : filteredChildren.slice(0, 4)
    const handleToggleShowAll = () => setShowAll(!showAll)

    const isMarkdownLinkList = useMemo(() => {
        return children.some((child: any) => {
            if (
                child?.props?.children?.props?.href?.length > 0 ||
                child?.props?.children?.[0]?.props?.href?.length > 0 ||
                child?.props?.children?.[1]?.props?.children?.[0]?.props?.href?.length > 0
            ) {
                return true
            } else {
                return false
            }
        })
    }, [children])

    return (
        <Container>
            <Scrollbar {...props} isMarkdownLinkList={isMarkdownLinkList}>
                {displayedChildren}
            </Scrollbar>
            {isMarkdownLinkList && filteredChildren.length > 4 && (
                <ToggleButton onClick={handleToggleShowAll}>
                    {showAll ? 'Show less' : 'Show more'}
                </ToggleButton>
            )}
        </Container>
    )
}

export default ExpandableList

const Container = styled.div``

const Scrollbar = styled.div<{ isMarkdownLinkList: boolean }>`
    display: grid;
    grid-template-columns: ${({ isMarkdownLinkList }) =>
        isMarkdownLinkList ? 'repeat(auto-fill, minmax(250px, 1fr))' : ''};
    gap: 10px;
    overflow-x: auto;
    &.scrollbar {
        /* Add any additional scrollbar styles here */
    }
`

const ToggleButton = styled.button``
